import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'
import ClientLayout from '@/layout/client'

/**
 * 公共路由
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  {
    path: '/',
    component: ClientLayout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/client/index')
      },
      {
        path: 'search/:searchContent',
        component: () => import('@/views/client/search'),
        meta: { title: '搜索' }
      },
      {
        path: 'collect',
        component: () => import('@/views/client/collect'),
        meta: { title: '最新收录' }
      },
      {
        path: 'about',
        component: () => import('@/views/client/about'),
        meta: { title: '关于本站' }
      },
      {
        path: 'log',
        component: () => import('@/views/client/log'),
        meta: { title: '更新日志' }
      },
      {
        path: 'setIndex',
        component: () => import('@/views/client/set-index'),
        meta: { title: '设为首页' }
      },
      {
        path: 'me',
        component: () => import('@/views/client/me'),
        meta: { title: '我的导航' }
      },
      {
        path: 'share/:shareUrl',
        component: () => import('@/views/client/share')
      }
    ]
  },
  {
    path: '/jy',
    component: () => import('@/views/client/simple'),
    hidden: true,
    meta: { title: '简约版' }
  },
  {
    path: '/nav/edit',
    component: () => import('@/views/nav/user/edit'),
    hidden: true,
    meta: { title: '自定义导航' }
  },
  {
    path: '/index',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/error/403'),
    hidden: true
  }
]

/**
 * 动态路由，基于用户权限动态去加载
 */
export const dynamicRoutes = [
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:authUser'],
    children: [
      {
        path: 'user/:id',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户角色', activeMenu: '/system/role' }
      }
    ]
  },
  {
    path: '/system/api/data/',
    component: Layout,
    hidden: true,
    permissions: ['system:api:page'],
    children: [
      {
        path: ':id',
        component: () => import('@/views/system/api'),
        name: 'APIData',
        meta: { title: 'API 接口数据', activeMenu: '/system/api' }
      }
    ]
  },
  {
    path: '/system/dictionary/data',
    component: Layout,
    hidden: true,
    permissions: ['system:dictionary:data:page'],
    children: [
      {
        path: ':id',
        component: () => import('@/views/system/dictionary/data'),
        name: 'DictionaryData',
        meta: { title: '字典数据', activeMenu: '/system/dictionary' }
      }
    ]
  },
  {
    path: '/system/nav/edit',
    component: () => import('@/views/nav/edit'),
    hidden: true,
    permissions: ['nav:category:site:edit'],
    meta: { title: '系统导航编辑' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

export default router
